import React from 'react'
import { PageLoading } from '../../components/PageLoading'
import { GlassCard } from '../../components/Layout/GlassCard'
import { useIdentityVerification } from './useIdentityVerification'
import { VerificationStatus } from './VerificationContext'
import { FailureCard } from './FailureCard'
import { InitiateVerificationCard } from './InidiateVerificationCard'
import { AwaitingVerificationCompletionCard } from './AwaitingVerificationCompletionCard'

export const EmbeddedVerificationModule: React.VFC = () => {
    const { verificationStatus } = useIdentityVerification()

    if ([VerificationStatus.Verified, VerificationStatus.NeedsSSN].includes(verificationStatus)) {
        return null
    }

    if (verificationStatus == VerificationStatus.Loading)
        return (
            <>
                <div style={{ minHeight: 200 }} />
                <PageLoading />
            </>
        )

    let content

    if (verificationStatus == VerificationStatus.Failed) {
        content = <FailureCard />
    } else if (
        verificationStatus === VerificationStatus.NotStarted ||
        verificationStatus === VerificationStatus.Active
    ) {
        content = <InitiateVerificationCard />
    } else if (verificationStatus === VerificationStatus.UserCompleted) {
        //should never happen, waiting is on the verification screen
        content = <AwaitingVerificationCompletionCard />
    }

    return <GlassCard>{content}</GlassCard>
}
